<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 13:51:29
 * @LastEditors: hanjiajun nujaijnah@live.com
 * @LastEditTime: 2022-08-05 10:18:04
 -->
<template>
  <div class="navMenu" ref="navMenu">
    <div
      class="item"
      v-for="(item, index) in productNavMenuConfigData"
      :key="index"
    >
      <span
        :class="[`tabItem ${active === index ? 'active' : ''}`]"
        @click="goPath(item.path, index)"
        >{{ item.name }}</span
      >
    </div>
    <span :class="toggleIcon" @click="toggle" v-if="active === 7"></span>
  </div>
</template>

<script>
export default {
  name: "navMenu",
  components: {},
  data() {
    return {
      toggleIcon: "el-icon-arrow-right",
      active: 0,
      productNavMenuConfigData: [
        {
          name: "产品运行总览",
          path: "productMonitorOverview"
        },
        {
          name: "运维服务监测",
          path: "maintenanceService"
        },
        {
          name: "路产管理平台",
          path: "roadPropertyMana"
        },
        {
          name: "机电运维平台",
          path: "electromechanicalMaintenance"
        },
        {
          name: "智慧服务区",
          path: "serviceArea"
        },
        {
          name: "路网态势感知平台",
          path: "roadNetworkSituationAwareness"
        },
        {
          name: "车型识别一体机",
          path: "vehicleIdentification"
        },
        {
          name: "护栏碰撞监测",
          path: "guardrailCollision"
        },
        {
          name: "非现场执法运维平台",
          path: "HardwareOperation"
        }
      ]
    };
  },
  methods: {
    toggle() {
      if (this.toggleIcon === "el-icon-arrow-right") {
        this.$refs.navMenu.style.right = "-294px";
        this.toggleIcon = "el-icon-arrow-left";
      } else {
        this.$refs.navMenu.style.right = "-40px";
        this.toggleIcon = "el-icon-arrow-right";
      }
    },
    /**
     * @description                   路由跳转
     * @param  {String}               路由name
     * @return {undefied}             无返回值
     */
    goPath(path, index) {
      this.$router.push({
        name: path
      });
      this.active = index;
    },
    /**
     * @description                   页面刷新时设置选中状态
     * @return {undefied}             无返回值
     */
    setRefreshSelectedStatus() {
      const matched = this.$route.matched[2].path.split("/");
      switch (matched[1]) {
        case "productMonitorOverview":
          this.active = 0;
          break;
        case "maintenanceService":
          this.active = 1;
          break;
        case "roadPropertyMana":
          this.active = 2;
          break;
        case "electromechanicalMaintenance":
          this.active = 3;
          break;
        case "serviceArea":
          this.active = 4;
          break;
        case "roadNetworkSituationAwareness":
          this.active = 5;
          break;
        case "vehicleIdentification":
          this.active = 6;
          break;
        case "guardrailCollision":
          this.active = 7;
          break;
        case "HardwareOperation":
          this.active = 8;
          break;
      }
    }
  },
  created() {
    this.setRefreshSelectedStatus();
  }
};
</script>

<style lang="less" scoped>
.navMenu {
  width: 302px;
  height: 766px;
  position: absolute;
  top: 279px;
  right: -20px;
  z-index: 10000;
  padding: 52px 0;
  background: url("/static/img/layout/navMenuBg.png");
  background-size: 100% 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  transition: all 1s;
  > span {
    display: inline-block;
    width: 20px;
    height: 40px;
    color: #00d6c8;
    font-size: 40px;
    position: absolute;
    font-weight: bold;
    top: 415px;
    left: 18px;
    // background: pink;
  }
  .item {
    width: 100%;
    height: 68px;
    text-align: right;
    display: block;
    .tabItem {
      font-size: 20px;
      white-space: nowrap;
      display: inline-block;
      text-align: left;
      height: 68px;
      line-height: 68px;
      color: #00d6c8;
      font-weight: normal;
      text-indent: 16px;
      cursor: pointer;
      border-radius: 34px 0 0 34px;
      background: linear-gradient(
        to right,
        rgba(1, 205, 192, 0.3) 0%,
        rgba(0, 0, 0, 0.1) 80%,
        rgba(0, 0, 0, 0.1) 100%
      );
    }
    .active {
      background: linear-gradient(
        to right,
        rgba(238, 215, 16, 0.3) 0%,
        rgba(0, 0, 0, 0.1) 80%,
        rgba(0, 0, 0, 0.1) 100%
      );
      color: #ffe400;
      font-weight: bold;
    }
  }
  .item:nth-of-type(1) {
    > span {
      width: 60%;
    }
  }
  .item:nth-of-type(2) {
    > span {
      width: 70%;
    }
  }
  .item:nth-of-type(3) {
    > span {
      width: 75%;
    }
  }
  .item:nth-of-type(4) {
    > span {
      width: 82%;
    }
  }
  .item:nth-of-type(5) {
    > span {
      width: 86%;
    }
  }
  .item:nth-of-type(6) {
    > span {
      width: 82%;
    }
  }
  .item:nth-of-type(7) {
    > span {
      width: 75%;
    }
  }
  .item:nth-of-type(8) {
    > span {
      width: 70%;
    }
  }
  .item:nth-of-type(9) {
    > span {
      width: 60%;
    }
  }
}
</style>
